module.exports = __webpack_public_path__ + "static/media/yasirah.bd0ba5e2.jpeg";